import React from "react";
import { withApollo } from "react-apollo";
import Modal from "react-awesome-modal";
import SimpleReactValidator from "simple-react-validator";

import {
  getListOfAttachments,
  createSubCatAttachment,
  updateSubCatAttachment,
  removeAttachment,
  removeSelected,
  getListOfAttachmentUsersByAttachmentId,
  addAttachmentUser,
  removeAttachmentUser,
} from "../../../services/graphql/queries/category-management";
import { getUserListQuery } from "../../../services/graphql/queries/user";

import { GRID_LIST } from "../../../services/graphql/queries/grid";

import ReactModal from "../../Common/ReactModal";
import InputComponent from "../../Common/form-component/InputComponent";
import SelectComponent from "../../Common/form-component/SelectComponent";
import TextAreComponent from "../../Common/form-component/TextAreComponent";
import { getAttachmentStatus } from "../../Common/ListOfInfoPortalStatus";
import DisplayErrors from "../../Common/DisplayErrors";

import {
  SET_TIMEOUT_VALUE,
  MAX_DOC_UPLOAD_SIZE,
} from "../../../constants/app-constants";
import { errorMessage } from "../../../miscellaneous/error-messages";
import { errorMsg, successMsg } from "../../../miscellaneous/react-toastify";

import popupLogo from "../../../static/images/popup-logo.png";

import config from "../../../config";
import { GET_PERMISSION } from "../../../services/graphql/queries/accessPermission";

class Attachments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      category: props.category,
      loading: false,
      errors: [],
      attachments: [],
      existingAttachmentNames: [],
      grids: [],
      atttachmentusers: [],
      fileinput: null,
      bulkfileinput: null,
      filesArray: [],
      selectedRecord: null,
      attachmentDetail: {
        tags: "",
        name: "",
        description: "",
        status: "",
      },
      addAttachmentModalVisible: false,
      updateAttachmentModalVisible: false,
      attachmentUserListModalVisible: false,
      addAttachmentUserModalVisible: false,
      isSearched: false,
      employeeId: "",
      name: "",
      allusers: {},
      users: [],
      userIds: [],
      userNames: [],
      deleteId: "",
      reactModalVisible: false,
      requireCancel: true,
      modalMessage: "",
      attachment: {},
      isOkDisabled: false,
      isUploading: false,
      viewByAll: false,
      viewByAllReactModalVisible: false,
      viewByAllRequireCancel: true,
      viewByAllModalMessage: "",
      removeAttachmentId: "",
      removeAttachmentReactModalVisible: false,
      removeAttachmentRequireCancel: true,
      removeAttachmentModalMessage: "",
      SentNotificationVisible: false,
      sendingEmail: false,
      sending: false,
      accessPermission: [],
      isSelectAll: false,
      selectedAttachments:[],
      isSelectAllDelete:false,
      removeAllAttachmentModalVisible:false,
    };
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
      element: (message) => <div style={{ color: "red" }}>{message}</div>,
    });
    this.handleInput = this.handleInput.bind(this);
    this.onUpdateAttachment = this.onUpdateAttachment.bind(this);
    this.onCreateDocUploadUsers = this.onCreateDocUploadUsers.bind(this);
    this.submitModal = this.submitModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.viewByAllSubmitModal = this.viewByAllSubmitModal.bind(this);
    this.viewByAllCloseModal = this.viewByAllCloseModal.bind(this);
    this.removeAttachmentSubmitModal = this.removeAttachmentSubmitModal.bind(
      this
    );
    this.removeAttachmentCloseModal = this.removeAttachmentCloseModal.bind(
      this
    );
    this.removeSelectedSubmitModal=this.removeSelectedSubmitModal.bind(this);

    this.removeAllAttachmentCloseModal=this.removeAllAttachmentCloseModal.bind(this);

  }

  handleInput(e) {
    let value = e.target.value;
    let name = e.target.name;
    this.setState((prevState) => {
      return {
        attachmentDetail: {
          ...prevState.attachmentDetail,
          [name]: value,
        },
      };
    });
  }

  onAddAttachmentModalVisible() {
    this.setState(
      {
        addAttachmentModalVisible: !this.state.addAttachmentModalVisible,
        errors: [],
      },
      () => {
        // if (this.state.addAttachmentModalVisible) this.getListOfGrids();
        // else this.getListOfAttachments();
        this.getListOfAttachments();
      }
    );
  }

  onUpdateAttachmentModalVisible() {
    this.validator.hideMessages()
    this.setState(
      {
        updateAttachmentModalVisible: !this.state.updateAttachmentModalVisible,
        SentNotificationVisible: false,
      },
      () => {
        if (!this.state.updateAttachmentModalVisible) {
          let attachmentDetail = {
            name: "",
            tags: "",
            description: "",
            status: "",
          };
          this.setState({
            selectedRecord: null,
            attachmentDetail: attachmentDetail,
          });
          this.getListOfAttachments();
        }
      }
    );
  }

  onAttachmentUserListModalVisible(attachment) {
    this.setState(
      {
        attachmentUserListModalVisible: !this.state
          .attachmentUserListModalVisible,
        selectedRecord: attachment,
      },
      () => {
        if (this.state.attachmentUserListModalVisible)
          this.getListOfAttachmentUsersByAttachmentId();
        else this.setState({ selectedRecord: null });
      }
    );
  }

  onAddAttachmentUserModalVisible(attachment) {
    this.setState(
      {
        addAttachmentUserModalVisible: !this.state
          .addAttachmentUserModalVisible,
        name: "",
        users: [],
        selectedRecord: attachment,
      },
      () => {
        if (this.state.addAttachmentUserModalVisible) {
          // if(this.state.userIds.length){
          //   for(let i=0; i<this.state.userIds.length; i++){
          //     this.state.users.push(this.state.allusers[this.state.userIds[i]]);
          //   }
          //   this.setState({users: this.state.users},
          //     ()=>{
          //       this.userListUpdate(this.state.users);
          //     }
          //   );
          // }else{
          this.getUserList();
          this.getAllUserList();
          // }
        }
      }
    );
  }

  onCancelClicked() {
    // if (this.state.userNames.length) {
    //   this.setState({ isSearched: false });
    // } else {
    this.setState(
      {
        isSearched: false,
        users: [],
        userIds: [],
        userNames: [],
        name: "",
        employeeId: "",
      },
      () => {
        this.onAddAttachmentUserModalVisible(null);
      }
    );
    // }
  }

  onSelectUser(e, user) {
    if (e.target.checked) {
      this.state.userIds.push(parseInt(user.Id));
      this.state.userNames.push(user.name);
    } else {
      for (let i = 0; i < this.state.userIds.length; i++) {
        if (this.state.userIds[i] == user.Id) {
          this.state.userIds.splice(i, 1);
          this.state.userNames.splice(i, 1);
        }
      }
    }
  }

  onCreateDocUploadUsers(e) {
    e.preventDefault();
    this.props.client
      .mutate({
        mutation: addAttachmentUser,
        variables: {
          attachmentId: this.state.selectedRecord.id,
          userId: this.state.userIds,
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        // this.setState({
        //   reactModalVisible: true,
        //   modalMessage: "User added successfully"
        // });
        successMsg("User added successfully");
        this.onAddAttachmentUserModalVisible(null);
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        this.onAddAttachmentUserModalVisible(null);
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({
          loading: false,
          errors: [errorMessage(error)],
          userNames: [],
          userIds: [],
          users: [],
        });
        this.timer = setTimeout(() => {
          this.setState({ errors: [] });
        }, SET_TIMEOUT_VALUE);
      });
  }

  userListUpdate(users) {
    var inputElements = document.getElementsByClassName("userCheckbox");
    for (let i = 0; i < inputElements.length; i++) {
      for (let j = 0; j < this.state.userIds.length; j++) {
        if (this.state.userIds[j] == users[i].Id) {
          inputElements[i].checked = true;
        }
      }
    }
  }

  submitModal() {
    this.props.client
      .mutate({
        mutation: removeAttachmentUser,
        variables: {
          id: this.state.deleteId,
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        this.setState({ reactModalVisible: false });
        successMsg("User removed successfully");
        // this.getListOfDocViewUsers();
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        this.setState({ reactModalVisible: false });
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.closeModal();
        this.setState({ loading: false, errors: [errorMessage(error)] });
        this.timer = setTimeout(() => {
          this.setState({ errors: [] });
        }, SET_TIMEOUT_VALUE);
      });
  }

  closeModal() {
    this.setState({ reactModalVisible: false, deleteId: "" });
  }

  viewByAllSubmitModal() {
    this.props.client
      .mutate({
        mutation: updateSubCatAttachment,
        variables: {
          attachmentId: this.state.attachment.id,
          sendNotification: false,
          data: {
            description: this.state.attachment.description,
            name: this.state.attachment.name,
            tags: this.state.attachment.tags,
            viewByAllUsers: this.state.viewByAll,
          },
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        successMsg("Updated successfully");
        this.viewByAllCloseModal();
        this.getListOfAttachments();
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, errors: [errorMessage(error)] });
        this.timer = setTimeout(() => {
          this.setState({ errors: [] });
        }, SET_TIMEOUT_VALUE);
      });
  }

  viewByAllCloseModal() {
    this.setState({
      viewByAllReactModalVisible: false,
      viewByAllModalMessage: "",
      attachment: {},
      viewByAll: false,
    });
  }

  removeAttachmentSubmitModal() {
    this.setState({ isOkDisabled: true });
    this.props.client
      .mutate({
        mutation: removeAttachment,
        variables: {
          attachmentId: this.state.removeAttachmentId,
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        this.setState({ isOkDisabled: false });
        successMsg("Attachment removed successfully");
        this.removeAttachmentCloseModal();
        this.getListOfAttachments();
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.removeAttachmentCloseModal();
        this.setState({
          loading: false,
          errors: [errorMessage(error)],
          isOkDisabled: false,
        });
        this.timer = setTimeout(() => {
          this.setState({ errors: [] });
        }, SET_TIMEOUT_VALUE);
      });
  }

  removeSelectedSubmitModal(){
    this.setState({ isOkDisabled: true });

    this.props.client
    .mutate({
      mutation:removeSelected,
      variables:{
        attachmentIds:this.state.selectedAttachments
      },
      fetchPolicy:"no-cache",
    })
    .then((result)=>{
      this.setState({isOkDisabled:false,selectedAttachments:[],removeAllAttachmentModalVisible:false});
      successMsg("Selected attachments removed successfully");
      this.removeAttachmentCloseModal();
      this.getListOfAttachments();
    })
    .catch((error)=>{
      console.log("~~~error: ", error);
      let message = errorMessage(error);
      errorMsg(message[0]);
      this.removeAttachmentCloseModal();
      this.setState({
        loading:false,
        errors:[errorMessage(error)],
        isOkDisabled:false,
      });
      this.timer = setTimeout(() => {
        this.setState({ errors: [] });
      }, SET_TIMEOUT_VALUE);
    })
  }

  // toggleSelectAttachment=(e,attachment)=>{
  //   const {selectedAttachments}=this.state;
  //   let updated=[...selectedAttachments];

  //   if(e.target.checked){
  //     updated.push(attachment.id);
  //   } else{
  //     updated=updated.filter((id)=>id!==attachment.id);
  //   }
   
  //   this.setState({selectedAttachments:updated})
  // }

  toggleSelectAttachment=(e, attachment)=> {
  let { selectedAttachments, attachments } = this.state;

  if (e.target.checked) {
    // selectedAttachments.push(attachment.id);
    selectedAttachments = [...selectedAttachments, attachment.id];
  } else {
    selectedAttachments = selectedAttachments.filter(id => id !== attachment.id);
  }

  // Update select-all state
  const isSelectAllDelete = selectedAttachments.length === attachments.length;

  this.setState({ selectedAttachments, isSelectAllDelete });
}


  removeAttachmentCloseModal() {
    this.setState({
      removeAttachmentReactModalVisible: false,
      removeAttachmentId: "",
    });
  }

  removeAllAttachmentCloseModal(){
    this.setState({
      removeAllAttachmentModalVisible:false,
      isSelectAll:false,
    });
  }

  onRemoveAttachment=(attachment)=> {
    console.log("attachment", attachment.id);
    
    this.setState({
      removeAttachmentId: attachment.id,
      removeAttachmentReactModalVisible: true,
      removeAttachmentModalMessage:
        "Are you sure, you want to delete this attachment?",
    });
  }

  onRemoveUser(id) {
    this.onAttachmentUserListModalVisible();
    this.setState({
      reactModalVisible: true,
      modalMessage: "Are you sure, you want to delete this user?",
      deleteId: id,
    });
  }

  onRemoveAllAttachment=()=>{
    this.setState({
      removeAllAttachmentModalVisible:true,
      modalMessage:"Are you sure,you want to remove all selected attachments?"
    });
  }

  onFormSubmit(e) {
    e.preventDefault();
    this.onAddAttachmentUserModalVisible();
  }

  onUpdateAttachmentClick(attachment) {
    const { tags, name, description, status } = attachment;
    let attachmentDetail = {
      tags: tags,
      name: name,
      description: description,
      status: status,
    };
    this.setState(
      {
        selectedRecord: attachment,
        attachmentDetail: attachmentDetail,
      },
      () => {
        this.onUpdateAttachmentModalVisible();
      }
    );
  }

  checkBoxChange(attachment, index) {
    let checkbox = document.getElementById("viewByAllUser" + index);
    if (checkbox.checked) {
      this.setState({
        viewByAllReactModalVisible: true,
        viewByAllModalMessage:
          "Are you sure. you want to view this project by all user?",
        viewByAll: checkbox.checked,
        attachment: attachment,
      });
    } else {
      this.setState({
        viewByAllReactModalVisible: true,
        viewByAllModalMessage:
          "Are you sure. you don't want to view this attachment by all user?",
        viewByAll: checkbox.checked,
        attachment: attachment,
      });
    }
  }
  onCheckboxChange() {
    this.setState({
      SentNotificationVisible: !this.state.SentNotificationVisible,
    });
  }
  onUpdateAttachment(e) {
    e.preventDefault();
    if (this.validator.allValid()) {
      const { tags, name, description, status } = this.state.attachmentDetail;
      this.setState({
        sending: true,
        sendingEmail: this.state.SentNotificationVisible,
      });
      this.props.client
        .mutate({
          mutation: updateSubCatAttachment,
          variables: {
            attachmentId: this.state.selectedRecord.id,
            sendNotification: this.state.SentNotificationVisible,
            data: {
              description: description,
              name: name,
              tags: tags,
              status: parseInt(status),
            },
          },
          fetchPolicy: "no-cache",
        })
        .then((result) => {
          // this.props.toggleMode(true);
          successMsg(result.data.updateSubCatAttachment.message)
          this.onUpdateAttachmentModalVisible();
        })
        .catch((error) => {
          console.log("~~~error: ", error);
          this.onUpdateAttachmentModalVisible();
          let message = errorMessage(error);
          if (this.state.SentNotificationVisible) {
            errorMsg("Email Sending Failed!");
          } else {
            errorMsg(message[0]); // Show general error
          }
          this.setState({ loading: false, errors: [errorMessage(error)] });
          this.timer = setTimeout(() => {
            this.setState({ errors: [] });
          }, SET_TIMEOUT_VALUE);
        })
        .finally(() => {
          // Reset loading states after API response
          this.setState({ sending: false, sendingEmail: false });
        });
    } else {
      this.validator.showMessages();
      // rerender to show messages for the first time
      // you can use the autoForceUpdate option to do this automatically`
      this.forceUpdate();
    }
  }

  addGrid(grid) {
    this.props.client
      .mutate({
        mutation: createSubCatAttachment,
        variables: {
          attachmentType: 2,
          subCategoryId: this.props.category.id,
          gridId: grid.id,
          data: [
            {
              fileData: "",
              fileName: "",
              fileType: "",
            },
          ],
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        // this.props.toggleMode(true);
        successMsg("Grid added successfully");
        this.onAddAttachmentModalVisible();
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        this.onAddAttachmentModalVisible();
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, errors: [errorMessage(error)] });
        this.timer = setTimeout(() => {
          this.setState({ errors: [] });
        }, SET_TIMEOUT_VALUE);
      });
  }

  compare(a, b) {
    const bandA = a.name.toUpperCase();
    const bandB = b.name.toUpperCase();
    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison;
  }

  getUserList() {
    this.setState({ loading: true, users: [], isSearched: true });
    this.props.client
      .query({
        query: getUserListQuery,
        variables: {
          employeeId: this.state.employeeId ? this.state.employeeId : null,
          name: this.state.name ? this.state.name : "",
          status: 1,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        var users = result.data.getListOfOrgUsers;
        users = users.sort((a, b) => this.compare(a, b));

        this.initialState = {
          users: users,
        };
        this.setState({ ...this.initialState, loading: false, error: "" });
        //   this.userListUpdate(users);
      })
      .catch((error) => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, error: error.message });
      });
  }

  getAllUserList() {
    // this.setState({ loading: true, isSearched: true });
    this.props.client
      .query({
        query: getUserListQuery,
        variables: {
          status: 1,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        var allusers = result.data.getListOfOrgUsers;
        allusers.forEach((element) => {
          this.state.allusers[element.Id] = element;
        });
        this.initialState = {
          allusers: this.state.allusers,
        };
        this.setState({ ...this.initialState, loading: false, error: "" });
      })
      .catch((error) => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, error: error.message });
      });
  }

  getListOfAttachmentUsersByAttachmentId() {
    this.setState({ loading: true });
    this.props.client
      .query({
        query: getListOfAttachmentUsersByAttachmentId,
        variables: {
          attachmentId: this.state.selectedRecord.id,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        var atttachmentusers =
          result.data.getListOfAttachmentUsersByAttachmentId;

        this.initialState = {
          atttachmentusers: atttachmentusers,
        };
        this.setState({ ...this.initialState, loading: false, error: "" });
      })
      .catch((error) => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, error: error.message });
      });
  }

  getListOfGrids() {
    this.setState({ loading: true, grids: [] });
    let name = document.getElementById("gridName").value;
    this.props.client
      .query({
        query: GRID_LIST,
        variables: {
          name: name ? name.trim() : "",
          status: 1,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        var grids = result.data.getListOfGrids;

        this.initialState = {
          grids: grids,
        };
        this.setState({ ...this.initialState, loading: false, error: "" });
      })
      .catch((error) => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, error: error.message });
      });
  }

  getListOfAttachments() {
    this.setState({ loading: true });
    this.props.client
      .query({
        query: getListOfAttachments,
        variables: {
          subCategoryId: this.props.category.id,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        var attachments = result.data.getListOfAttachments;

        let existingAttachmentNames = [];
        for (let i = 0; i < attachments.length; i++) {
          if (attachments[i].attachmentType == 1) {
            existingAttachmentNames.push(attachments[i].name);
          }
        }

        this.initialState = {
          attachments: attachments,
          existingAttachmentNames: existingAttachmentNames,
        };
        this.setState({ ...this.initialState, loading: false, error: "" });
      })
      .catch((error) => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, error: error.message });
      });
  }

  getPermission() {
    this.props.client
      .query({
        query: GET_PERMISSION,
        fetchPolicy: "network-only",
      })
      .then((result) => {
        console.log(
          "notify permission ",
          JSON.parse(result.data.getPermission)
        );
        this.setState(
          {
            accessPermission: JSON.parse(result.data.getPermission),
          },
        );
      })
      .catch((error) => {
        console.log("~~~error: ", error);
      });
  }

  componentDidMount() {
    this.getListOfAttachments();
    this.getPermission();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.category !== this.props.category) {
      this.getListOfAttachments();
    }
  }

  isAttachmentDeletable(e, attachmentData, index) {
    const { isSelectAll, attachments } = this.state;
    if (isSelectAll) return;
    attachments[index].canDeletable = e.target.checked;
    this.setState({ attachments: attachments });
  }

    isSelectAll(e) {
    var attachments = this.state.attachments;

    for (let i = 0; i < attachments.length; i++) {
      if (e.target.checked) attachments[i].canDeletable = true;
      else attachments[i].canDeletable = false;
    }

    this.initialState = {
      attachments: attachments,
    };
    this.setState({ ...this.initialState, isSelectAll: e.target.checked });
  }

//   isSelectAllForDelete(e) {
//   const { attachments } = this.state;
//   const updatedAttachments = attachments.map(a => ({
//     ...a,
//     selectedForDelete: e.target.checked
//   }));
//   this.setState({
//     attachments: updatedAttachments,
//     isSelectAllDelete: e.target.checked,
//   });
// }

isSelectAllForDelete(e) {
  const checked = e.target.checked;
  const selectedAttachments = checked
    ? this.state.attachments.map(a => a.id)
    : [];

  this.setState({
    selectedAttachments,
    isSelectAllDelete: checked,
  });
}



  onFilesSelect(e) {
    e.preventDefault();
    let files = e.target.files;
    let filesCount = 0,
      filesValidateSize = 0,
      fileNameDuplicateCount = 0;
    var notAcceptableFileNames = "",
      fileSizeExceedFileNames = "",
      duplicateNames = "";

    var filesArr = [],
      selectedFileNames = [];

    for (let i = 0; i < files.length; i++) {
      selectedFileNames.push(files[i].name);
    }

    for (let i = 0; i < files.length; i++) {
      if (this.isAcceptedFile(files[i])) {
        filesCount = filesCount + 1;
        if (this.validateSize(files[i])) {
          filesValidateSize = filesValidateSize + 1;
          if (this.state.existingAttachmentNames.includes(files[i].name)) {
            fileNameDuplicateCount = fileNameDuplicateCount + 1;
            duplicateNames = duplicateNames + " " + files[i].name;
          } else {
            filesArr.push(files[i]);
          }
        } else {
          fileSizeExceedFileNames =
            fileSizeExceedFileNames + " " + files[i].name;
        }
      } else {
        notAcceptableFileNames = notAcceptableFileNames + " " + files[i].name;
      }
    }

    let errors = [];
    if (duplicateNames != "") {
      let msg = filesArr.length ? " Other files will be upload" : "";
      errors.push(duplicateNames + " " + "file name(s) are duplicate." + msg);
    }
    if (notAcceptableFileNames != "") {
      let msg = filesArr.length ? " Other files will be upload" : "";
      errors.push(
        notAcceptableFileNames + " " + "file(s) are not supported." + msg + "Please contact administrator"
      );
    }
    if (fileSizeExceedFileNames != "") {
      let msg = filesArr.length ? " Other files will be upload." : "";
      errors.push(
        fileSizeExceedFileNames +
          " " +
          "file(s) are exceeds file size." +
          msg +
          "Max file upload size is " +
          MAX_DOC_UPLOAD_SIZE +
          " MB"
      );
    }
    this.setState({ errors: errors });

    if (filesArr.length) {
      this.setState({ loading: true, isUploading: true });

      const formData = new FormData();
      formData.append("subCategoryId", this.props.category.id);
      formData.append("attachmentType", 1);
      for (let i = 0; i < filesArr.length; i++) {
        formData.append("file", filesArr[i]);
      }
      let token = localStorage.getItem("token");
      fetch(config.REST_URI + "attachment/upload", {
        method: "POST",
        headers: {
          Authorization: token,
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((result) => {
          console.log("Success:", result);
          if (result.msg) successMsg("Uploaded successfully");
          if (result.error) errorMsg(result.error);
          this.setState({
            loading: false,
            isUploading: false,
            fileinput: null,
            bulkfileinput: null,
          });
          this.onAddAttachmentModalVisible();
        })
        .catch((error) => {
          console.error("Error while uploading:", error);
          this.setState({
            loading: false,
            isUploading: false,
            fileinput: null,
            bulkfileinput: null,
            errors: [errorMessage(error)],
          });
          errorMsg(error.message, false);
        });
    }
  }

  isAcceptedFile(file) {
    let fileName = file.name;
    if (
      fileName.includes(".xlsx") ||
      fileName.includes(".xls") ||
      fileName.includes(".doc") ||
      fileName.includes(".docx") ||
      fileName.includes(".ppt") ||
      fileName.includes(".pptx") ||
      fileName.includes(".pdf") ||
      fileName.includes(".XLSX") ||
      fileName.includes(".XLS") ||
      fileName.includes(".DOC") ||
      fileName.includes(".DOCX") ||
      fileName.includes(".PPT") ||
      fileName.includes(".PPTX") ||
      fileName.includes(".PDF") ||
      fileName.includes(".zip") ||
      fileName.includes(".ZIP") ||
      fileName.includes(".rar") ||
      fileName.includes(".RAR") ||
      fileName.includes(".png") ||
      fileName.includes(".PNG") ||
      fileName.includes(".jpg") ||
      fileName.includes(".JPG") ||
      fileName.includes(".jpeg") ||
      fileName.includes(".JPEG") ||
      fileName.includes(".gif") ||
      fileName.includes(".GIF") ||
      fileName.includes(".mpeg") ||
      fileName.includes(".MPEG") ||
      fileName.includes(".bmp") ||
      fileName.includes(".BMP") ||
      fileName.includes(".dwg") ||
      fileName.includes(".vsd") ||
      fileName.includes(".vsdx") ||
      fileName.includes(".vsdm")
    ) {
      return true;
    } else {
      this.setState({
        errors: [
          "Please upload only these file types .xlsx, .xls, .doc, .docx, .ppt, .pptx, .pdf, .zip, .rar, .png, .jpg, .jpeg, .gif, .mpeg, .bmp",
        ],
      });
  
      return false;
    }
  }

  validateSize = (file) => {
    var FileSize = file.size / 1024; // in KB
    console.log("img size", FileSize, file.size);
    if (FileSize > MAX_DOC_UPLOAD_SIZE * 1024) {
      this.setState({
        errors: ["Max file upload size is " + MAX_DOC_UPLOAD_SIZE + " MB"],
      });
      // setTimeout(() => {
      //   this.setState({ errors: [] });
      // }, SET_TIMEOUT_VALUE);
      return false;
    } else {
      return true;
    }
  };

  render() {
    console.log("this.state.attachments in doc upload",this.state.attachment);
          

    
    const {
      loading,
      errors,
      attachments,
      grids,
      atttachmentusers,
      attachmentDetail,
      addAttachmentModalVisible,
      updateAttachmentModalVisible,
      attachmentUserListModalVisible,
      addAttachmentUserModalVisible,
      users,
      isSearched,
      name,
      reactModalVisible,
      requireCancel,
      modalMessage,
      isOkDisabled,
      isUploading,
      viewByAllReactModalVisible,
      viewByAllRequireCancel,
      viewByAllModalMessage,
      removeAttachmentReactModalVisible,
      removeAttachmentRequireCancel,
      removeAttachmentModalMessage,
      accessPermission
    } = this.state;
    const statusOptions =
      attachmentDetail && attachmentDetail.status
        ? getAttachmentStatus(attachmentDetail.status)
        : [];
    return (
      
      <div>
        <ReactModal
          reactModalVisible={reactModalVisible}
          submitModal={this.submitModal}
          modalMessage={modalMessage}
          requireCancel={requireCancel}
          closeModal={this.closeModal}
        />
        <ReactModal
          reactModalVisible={viewByAllReactModalVisible}
          submitModal={this.viewByAllSubmitModal}
          modalMessage={viewByAllModalMessage}
          requireCancel={viewByAllRequireCancel}
          closeModal={this.viewByAllCloseModal}
        />
        <ReactModal
          reactModalVisible={removeAttachmentReactModalVisible}
          submitModal={this.removeAttachmentSubmitModal}
          modalMessage={removeAttachmentModalMessage}
          requireCancel={removeAttachmentRequireCancel}
          closeModal={this.removeAttachmentCloseModal}
          isOkDisabled={isOkDisabled}
        />
        <ReactModal
          reactModalVisible={this.state.removeAllAttachmentModalVisible}
          submitModal={this.removeSelectedSubmitModal}
          modalMessage={modalMessage}
          requireCancel={removeAttachmentRequireCancel}
          closeModal={this.removeAllAttachmentCloseModal}
          isOkDisabled={isOkDisabled}
        />
        <div className="row">
          <div className="col-md-12">
            <div className="row align-items-center">
              <div className="col-md-6">
                <h1 className="heading m-b-0">Attachments</h1>
              </div>
              <div className="col-md-6 text-right d-flex justify-content-end">
              <a
                className="link-click"
                href="#"
                data-placement="bottom"
                title="Upload"
                style={{ fontSize: "16px", marginTop:"10px"}}
                data-toggle="modal"
                data-target="#addattachment"
                onClick={() => this.onAddAttachmentModalVisible()}
              >
                <svg
                  x="0px"
                  y="0px"
                  width="16px"
                  height="16px"
                  viewBox="0 0 16 16"
                  enableBackground="new 0 0 16 16"
                  xmlSpace="preserve"
                >
                  <g>
                    <circle
                      fill="none"
                      stroke="#69951a"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      cx={8}
                      cy={8}
                      r="7.5"
                    />
                    <g>
                      <line
                        fill="none"
                        stroke="#69951a"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        x1="2.5"
                        y1={8}
                        x2="13.5"
                        y2={8}
                      />
                      <line
                        fill="none"
                        stroke="#69951a"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        x1={8}
                        y1="2.5"
                        x2={8}
                        y2="13.5"
                      />
                    </g>
                  </g>
                </svg>{" "}
                Add Attachments
              </a>
              {accessPermission && accessPermission[248] && (
                              <button
                                className="btn btn-danger"
                                style={{ marginLeft: "5%" }}
                                onClick={this.onRemoveAllAttachment}
                                disabled={this.state.selectedAttachments.length === 0}
                              >
                                Delete Selected
                              </button>
                )}

                          {/* <button
                                className="btn btn-danger"
                                style={{ marginLeft: "5%" ,opacity: accessPermission && accessPermission[248] ? 1 : 0.5,
                                    cursor: accessPermission && accessPermission[247] ? "pointer" : "not-allowed",}}
                                // style={{
                                //     opacity: accessPermission && accessPermission[247] ? 1 : 0.5,
                                //     cursor: accessPermission && accessPermission[247] ? "pointer" : "not-allowed",
                                //   }}
                                // onClick={() => this.removeSelectedSubmitModal()}
                                // onClick={()=>this.onRemoveAllAttachment()}
                                onClick={(e) => {
                                    if (!(accessPermission && accessPermission[248])) {
                                      e.preventDefault();
                                      e.stopPropagation();
                                    } else {
                                      this.onRemoveAllAttachment()
                                    }
                                  }}
                                disabled={this.state.selectedAttachments.length === 0}
                              >
                                   Delete Selected Files
                            </button> */}
            </div>
            </div>
            
            <div className="table-responsive mt-3" style={{ height: "20vh" }}>
              <table className="table table-style-1 ">
                <thead className="" style={{backgroundColor:""}}>
                  <tr>
                    {accessPermission && accessPermission[248] && (
                      <th className="bg-primar" scope="col" width={10}>
                      
                      {attachments.length ? (
                          <>
                            
                            <input
                                type="checkbox"
                                className="form-contro"
                                style={{ height: "18px", marginTop: "-20px", }}
                                onChange={(e) => this.isSelectAllForDelete(e)}
                                checked={this.state.isSelectAllDelete}
                              />
                          </>
                        ) : null}
                    </th>
                    )}
                    
                    {/* <th scope="col" width={100}>{attachments.length ? (
                          <>
                            
                            <input
                                type="checkbox"
                                className="form-control"
                                style={{ height: "18px", marginTop: "-20px", marginLeft: "10px" }}
                                onChange={(e) => this.isSelectAllForDelete(e)}
                                checked={this.state.isSelectAllDelete}
                              />
                          </>
                        ) : null}</th> */}
                    <th scope="col" width={200} >
                      FILE NAME
                    </th>
                    <th className=" text-center" scope="col" width={90} >
                      VIEW BY ALL USERS
                    </th>
                    
                    <th className="" scope="col" width={50}  >
                     ACTION
                            {/* <div className="d-flex justify-content-betwee align-items-end">
                              <div className="bg-inf"style={{width:"50%"}} >ACTION</div>
                              
                          
                          <div className="bg-inf" style={{width:"35%"}}>
                            {attachments.length ? (
                          <>
                            
                            <input
                                type="checkbox"
                                className="form-control"
                                style={{ height: "18px", marginTop: "-20px", marginLeft: "10px" }}
                                onChange={(e) => this.isSelectAllForDelete(e)}
                                checked={this.state.isSelectAllDelete}
                              />
                          </>
                        ) : null}
                          </div>
                          
                          <div className="bg-inf d-flex justify-content-end" style={{width:"56%"}}>
                            <button
                                className="btn btn-danger"
                                // style={{ marginLeft: "26%" }}
                                // onClick={() => this.removeSelectedSubmitModal()}
                                onClick={()=>this.onRemoveAllAttachment()}
                                disabled={this.state.selectedAttachments.length === 0}
                              >
                                   Delete All
                            </button>
                          </div>
                        
                      </div>          */}
                    </th>
                  </tr>
                </thead>
                {/* "#d0f0c0"  */}
                <tbody>
                  {attachments.length
                    ? attachments.map((attachment, index) => {
                        const isSelected =this.state.selectedAttachments.includes(attachment.id); // or individual selected
                           console.log("isselected",isSelected);
                               

                        return (
                          <tr key={index}
                              style={{
                                  backgroundColor: isSelected ? "#d0f0c0"  : "transparent", // light green if selected
                                  transition: "background-color 0.2s", // optional smooth effect
                                }}
                          >
                            {accessPermission && accessPermission[248] && (
                                  <td data-toggle="tooltip" style={{backgroundColor: "inherit"}}
                              data-placement="bottom">
                                
                              <input
                                type="checkbox"
                                className=""
                                style={{ height: "18px", marginTop: "0", }}
                                onChange={(e) => this.toggleSelectAttachment(e, attachment)}
                                checked={isSelected}
                              />
                            </td>
                                )}
                            
                            <td
                              data-toggle="tooltip"
                              data-placement="bottom"
                              title={attachment.name}
                              style={{backgroundColor: "inherit"}}
                            >
                              {attachment.name.length > 40
                                ? attachment.name.substring(0, 40) + "..."
                                : attachment.name}
                            </td>
                            <td style={{ textAlign: "center" , backgroundColor: "inherit"}}>
                              <input
                                type="checkbox"
                                id={"viewByAllUser" + index}
                                checked={attachment.viewByAllUsers}
                                onClick={() =>
                                  this.checkBoxChange(attachment, index)
                                }
                              />
                            </td>
                            <td style={{backgroundColor: "inherit"}}>
                              <a
                                className="link-click"
                                href="#"
                                data-toggle="tooltip"
                                data-placement="bottom"
                                title="Add Description"
                                style={{backgroundColor: "inherit"}}
                                onClick={() =>
                                  this.onUpdateAttachmentClick(attachment)
                                }
                              >
                                <svg
                                  x="0px"
                                  y="0px"
                                  width="16px"
                                  height="16px"
                                  viewBox="0 0 16 16"
                                  data-toggle="modal"
                                  data-target="#createNewVersion"
                                >
                                  <g transform="translate(0, 0)">
                                    <line
                                      fill="none"
                                      stroke="#69951a"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeMiterlimit={10}
                                      x1="4.5"
                                      y1="11.5"
                                      x2="11.5"
                                      y2="11.5"
                                      data-color="color-2"
                                    />
                                    <line
                                      fill="none"
                                      stroke="#69951a"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeMiterlimit={10}
                                      x1="4.5"
                                      y1="8.5"
                                      x2="11.5"
                                      y2="8.5"
                                      data-color="color-2"
                                    />
                                    <line
                                      fill="none"
                                      stroke="#69951a"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeMiterlimit={10}
                                      x1="4.5"
                                      y1="5.5"
                                      x2="6.5"
                                      y2="5.5"
                                      data-color="color-2"
                                    />
                                    <polygon
                                      fill="none"
                                      stroke="#69951a"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeMiterlimit={10}
                                      points="9.5,0.5 1.5,0.5 1.5,15.5 14.5,15.5 14.5,5.5 "
                                    />
                                    <polyline
                                      fill="none"
                                      stroke="#69951a"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeMiterlimit={10}
                                      points="9.5,0.5 9.5,5.5 14.5,5.5 "
                                    />
                                  </g>
                                </svg>
                              </a>
                              {!attachment.viewByAllUsers ? (
                                <a
                                  className="link-click m-l-45"
                                  href="#"
                                  data-toggle="tooltip"
                                  data-placement="bottom"
                                  title="Attachment User"
                                  onClick={() =>
                                    this.onAttachmentUserListModalVisible(
                                      attachment
                                    )
                                  }
                                >
                                  {/* <svg
                                    x="0px"
                                    y="0px"
                                    width="16px"
                                    height="16px"
                                    viewBox="0 0 16 16"
                                    data-toggle="modal"
                                    data-target="#selectGeoId"
                                  >
                                    <g transform="translate(0, 0)">
                                      <line
                                        fill="none"
                                        stroke="#69951a"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeMiterlimit={10}
                                        x1="4.5"
                                        y1="11.5"
                                        x2="11.5"
                                        y2="11.5"
                                        data-color="color-2"
                                      />
                                      <line
                                        fill="none"
                                        stroke="#69951a"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeMiterlimit={10}
                                        x1="4.5"
                                        y1="8.5"
                                        x2="11.5"
                                        y2="8.5"
                                        data-color="color-2"
                                      />
                                      <line
                                        fill="none"
                                        stroke="#69951a"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeMiterlimit={10}
                                        x1="4.5"
                                        y1="5.5"
                                        x2="6.5"
                                        y2="5.5"
                                        data-color="color-2"
                                      />
                                      <polygon
                                        fill="none"
                                        stroke="#69951a"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeMiterlimit={10}
                                        points="9.5,0.5 1.5,0.5 1.5,15.5 14.5,15.5 14.5,5.5 "
                                      />
                                      <polyline
                                        fill="none"
                                        stroke="#69951a"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeMiterlimit={10}
                                        points="9.5,0.5 9.5,5.5 14.5,5.5 "
                                      />
                                    </g>
                                  </svg> */}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 640 512"
                                    width="18px"
                                    height="18px"
                                  >
                                    <path
                                      fill="#69951a"
                                      d="M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192l42.7 0c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0L21.3 320C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7l42.7 0C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3l-213.3 0zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352l117.3 0C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7l-330.7 0c-14.7 0-26.7-11.9-26.7-26.7z"
                                    />
                                  </svg>
                                </a>
                              ) : null}
                              {!attachment.viewByAllUsers ? (
                                <a
                                  className="link-click m-l-45"
                                  href="#"
                                  data-toggle="tooltip"
                                  data-placement="bottom"
                                  title="Add User"
                                  onClick={() =>
                                    this.onAddAttachmentUserModalVisible(
                                      attachment
                                    )
                                  }
                                >
                                  {/* <svg
                                    x="0px"
                                    y="0px"
                                    width="16px"
                                    height="16px"
                                    viewBox="0 0 16 16"
                                    data-toggle="modal"
                                    data-target="#selectGeoId"
                                  >
                                    <g transform="translate(0, 0)">
                                      <line
                                        fill="none"
                                        stroke="#69951a"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeMiterlimit={10}
                                        x1="4.5"
                                        y1="11.5"
                                        x2="11.5"
                                        y2="11.5"
                                        data-color="color-2"
                                      />
                                      <line
                                        fill="none"
                                        stroke="#69951a"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeMiterlimit={10}
                                        x1="4.5"
                                        y1="8.5"
                                        x2="11.5"
                                        y2="8.5"
                                        data-color="color-2"
                                      />
                                      <line
                                        fill="none"
                                        stroke="#69951a"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeMiterlimit={10}
                                        x1="4.5"
                                        y1="5.5"
                                        x2="6.5"
                                        y2="5.5"
                                        data-color="color-2"
                                      />
                                      <polygon
                                        fill="none"
                                        stroke="#69951a"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeMiterlimit={10}
                                        points="9.5,0.5 1.5,0.5 1.5,15.5 14.5,15.5 14.5,5.5 "
                                      />
                                      <polyline
                                        fill="none"
                                        stroke="#69951a"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeMiterlimit={10}
                                        points="9.5,0.5 9.5,5.5 14.5,5.5 "
                                      />
                                    </g>
                                  </svg> */}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 640 512"
                                    width="18px"
                                    height="18px"
                                  >
                                    <path
                                      fill="#69951a"
                                      d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM504 312l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
                                    />
                                  </svg>
                                </a>
                              ) : null}
                              <a
                                href="#"
                                className="link-delete m-l-45"
                                data-toggle="tooltip"
                                data-placement="bottom"
                                title="Delete"
                              >
                                <svg
                                  x="0px"
                                  y="0px"
                                  width="16px"
                                  height="16px"
                                  viewBox="0 0 16 16"
                                  onClick={(e) => {
                                    if (!(accessPermission && accessPermission[247])) {
                                      e.preventDefault();
                                      e.stopPropagation();
                                    } else {
                                      this.onRemoveAttachment(attachment);
                                    }
                                  }}
                                  style={{
                                    opacity: accessPermission && accessPermission[247] ? 1 : 0.5,
                                    cursor: accessPermission && accessPermission[247] ? "pointer" : "not-allowed",
                                  }}
                                >
                                  <g transform="translate(0, 0)">
                                    <path
                                      fill="none"
                                      stroke="#69951a"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeMiterlimit={10}
                                      d="M2.5,6.5v7 c0,1.105,0.895,2,2,2h8c1.105,0,2-0.895,2-2v-7"
                                    />
                                    <line
                                      data-color="color-2"
                                      fill="none"
                                      stroke="#69951a"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeMiterlimit={10}
                                      x1="1.5"
                                      y1="3.5"
                                      x2="15.5"
                                      y2="3.5"
                                    />
                                    <polyline
                                      data-color="color-2"
                                      fill="none"
                                      stroke="#69951a"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeMiterlimit={10}
                                      points=" 6.5,3.5 6.5,0.5 10.5,0.5 10.5,3.5 "
                                    />
                                    <line
                                      fill="none"
                                      stroke="#69951a"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeMiterlimit={10}
                                      x1="8.5"
                                      y1="7.5"
                                      x2="8.5"
                                      y2="12.5"
                                    />
                                    <line
                                      fill="none"
                                      stroke="#69951a"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeMiterlimit={10}
                                      x1="11.5"
                                      y1="7.5"
                                      x2="11.5"
                                      y2="12.5"
                                    />
                                    <line
                                      fill="none"
                                      stroke="#69951a"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeMiterlimit={10}
                                      x1="5.5"
                                      y1="7.5"
                                      x2="5.5"
                                      y2="12.5"
                                    />
                                  </g>
                                </svg>
                              </a>
                           
                            </td>
                          </tr>
                        );
                      })
                    : null}
                </tbody>
              </table>
              {!attachments.length && !loading ? (
                <div style={{ textAlign: "center" }}>No Data</div>
              ) : null}
            </div>
          </div>
        </div>
        {/* Add Attachment Modal Start */}
        <Modal
          visible={addAttachmentModalVisible}
          effect="fadeInDown"
          width="900"
        >
          <div style={{ padding: "20px" }}>
            <div className="modal-content" style={{ border: "none" }}>
              <div className="modal-body" style={{ paddingTop: 0 }}>
                <div style={{ display: "flex" }}>
                  <figure>
                    <img src={popupLogo} />
                  </figure>
                  <h1 className="heading m-l-45 m-b-35">Document Upload</h1>
                </div>
                <div
                  className="row"
                  style={{
                    display: errors.length === 0 ? "none" : "block",
                  }}
                >
                  <div className="col-md-12">
                    <div className="alert alert-success" role="alert">
                      <div className="row">
                        <span className="danger-link">
                          <DisplayErrors errors={errors} />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <div className="upload-btn-wrapper">
                      <button
                        className="btn btn-light"
                        onClick={() => {
                          this.state.fileinput.click();
                        }}
                      >
                        Upload
                      </button>
                      {/* <input type="file" name="myfile" /> */}
                      <input
                        type="file"
                        id="uploadAttachments"
                        hidden
                        name="attachments"
                        // accept="image/gif,image/jpeg,image/png"
                        accept=".xlsx, .xls, .doc, .docx, .ppt, .pptx, .pdf, .zip, .rar, png, jpg, jpeg, gif, mpeg, bmp"
                        ref={(fileinput) => {
                          this.state.fileinput = fileinput;
                        }}
                        onChange={(e) => {
                          if (e.target.files.length) this.onFilesSelect(e);
                        }}
                      />
                    </div>
                    <div className="upload-btn-wrapper">
                      <button
                        className="btn btn-light m-l-45"
                        onClick={() => {
                          this.state.bulkfileinput.click();
                        }}
                      >
                        Upload - Multiple
                      </button>
                      <input
                        type="file"
                        id="uploadAttachments"
                        hidden
                        name="attachments"
                        multiple={true}
                        accept=".xlsx, .xls, .doc, .docx, .ppt, .pptx, .pdf, .zip, .rar, png, jpg, jpeg, gif, mpeg, bmp"
                        ref={(bulkfileinput) => {
                          this.state.bulkfileinput = bulkfileinput;
                        }}
                        onChange={(e) => {
                          if (e.target.files.length) this.onFilesSelect(e);
                        }}
                      />
                    </div>
                  </div>
                </div>
                {/* {isUploading ? (
                  <div
                    className="blink blink-two"
                    style={{ fontSize: "18px", marginTop: "5px" }}
                  >
                    Uploading<span className="dot-flashing"></span>
                  </div>
                ) : null} */}
                {isUploading ? (
                  <div className="uploading-container">
                    <span className="uploading-text">Uploading</span>
                    <span className="uploading-dot dot-1">.</span>
                    <span className="uploading-dot dot-2">.</span>
                    <span className="uploading-dot dot-3">.</span>
                  </div>
                ) : null}

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-default popup-button-default text-w-light"
                    data-dismiss="modal"
                    onClick={() => this.onAddAttachmentModalVisible()}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger popup-button-danger"
                  >
                    Done
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        {/* Add Attachment Modal End */}

        {/* Update Attachment Modal Start */}
        <Modal
          visible={updateAttachmentModalVisible}
          effect="fadeInDown"
          width="900"
        >
          <div style={{ padding: "40px 40px" }}>
            <form onSubmit={this.onUpdateAttachment}>
              <div className="modal-content" style={{ border: "none" }}>
                <div className="modal-body">
                  <div style={{ display: "flex" }}>
                    <figure>
                      <img src={popupLogo} />
                    </figure>
                    <h1 className="heading m-l-45 m-b-35">Update</h1>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-6">
                      <InputComponent
                        required
                        type="text"
                        title="name"
                        name="name"
                        label="Attachment Name"
                        value={attachmentDetail.name}
                        placeholder="Please Enter Name"
                        handleChange={this.handleInput}
                        validator={this.validator}
                        validation="required"
                      />
                    </div>
                    <div className="col-6">
                      <SelectComponent
                        required
                        label={"Status"}
                        title={"status"}
                        name={"status"}
                        options={statusOptions}
                        optionKey={"name"}
                        valueKey={"id"}
                        value={attachmentDetail.status}
                        placeholder={"Select Status"}
                        handleChange={this.handleInput}
                        validator={this.validator}
                        validation="required"
                      />
                    </div>
                    <div className="col-6">
                      <InputComponent
                        required
                        type="text"
                        title="tags"
                        name="tags"
                        label="Tags"
                        value={attachmentDetail.tags}
                        placeholder="Comma Separated Values"
                        handleChange={this.handleInput}
                        validator={this.validator}
                        validation="required"
                      />
                    </div>
                    <div className="col-6">
                      <TextAreComponent
                        required
                        title="Description"
                        name="description"
                        label="Description"
                        value={attachmentDetail.description}
                        placeholder="Enter Description"
                        handleChange={this.handleInput}
                        validator={this.validator}
                        validation="required"
                      />
                    </div>
                    <div className="col-6">
                      <input
                        className=""
                        style={{}}
                        type="checkbox"
                        checked={this.state.SentNotificationVisible}
                        //onClick={() => this.onCheckboxChange()}
                        onChange={() =>
                          this.setState({
                            SentNotificationVisible: !this.state
                              .SentNotificationVisible,
                          })
                        }
                      />
                      <label
                        className="custom-checkbox"
                        style={{
                          fontWeight: "600",
                          fontSize: "16px",
                          marginLeft: "4px",
                        }}
                      >
                        Send Notification
                      </label>
                      {this.state.sendingEmail && (
                        <p
                          className=""
                          style={{
                            color: "black",
                            fontSize: "16px",
                            marginTop: "10px",
                            marginLeft: "20px",
                            fontWeight: "600",
                            backgroundColor: "",
                          }}
                        >
                          {/* Email sending<span className="dot-flashing"></span> */}
                          <div className="uploading-container">
                            <span className="uploading-text">
                              Email sending
                            </span>
                            <span className="uploading-dot dot-1">.</span>
                            <span className="uploading-dot dot-2">.</span>
                            <span className="uploading-dot dot-3">.</span>
                          </div>
                        </p>
                      )}
                      {/* this.state.sendingEmail && */}
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-default popup-button-default text-w-light"
                    data-dismiss="modal"
                    onClick={() => this.onUpdateAttachmentModalVisible()}
                  >
                    Cancel 
                  </button>
                  <button
                    type="submit"
                    className="btn btn-danger popup-button-danger"
                    disabled={this.state.sending}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </Modal>
        {/* Update Attachment Modal End */}

        {/* Attachment User List Modal Start */}
        <Modal
          visible={attachmentUserListModalVisible}
          effect="fadeInDown"
          width="900"
        >
          <div style={{ padding: "40px 40px" }}>
            <div className="modal-content" style={{ border: "none" }}>
              <div className="modal-body" style={{ paddingTop: 0 }}>
                <div style={{ display: "flex" }}>
                  <figure>
                    <img src={popupLogo} />
                  </figure>
                  <h1 className="heading m-l-45 ">Attachment Users</h1>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-12">
                    <div>
                      <div
                        className="table-responsive"
                        style={{ height: "335px" }}
                      >
                        <table
                          className="table table-style-1"
                          style={{ overflow: "auto" }}
                        >
                          <thead>
                            <tr>
                              <th scope="col" width={180}>
                                EMAIL ID
                              </th>
                              <th scope="col" width={180}>
                                NAME
                              </th>
                              <th scope="col" width={200}>
                                ACTION
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {atttachmentusers.length
                              ? atttachmentusers.map(
                                  (atttachmentuser, index) => {
                                    return (
                                      <tr key={index}>
                                        <td>
                                          {atttachmentuser.userId.loginId}
                                        </td>
                                        <td>
                                          {atttachmentuser.userDetail.name}
                                        </td>
                                        <td>
                                          <a
                                            href="#"
                                            className="link-delete m-l-45"
                                            data-toggle="tooltip"
                                            data-placement="bottom"
                                            title="Delete"
                                          >
                                            <svg
                                              x="0px"
                                              y="0px"
                                              width="16px"
                                              height="16px"
                                              viewBox="0 0 16 16"
                                              onClick={() =>
                                                this.onRemoveUser(
                                                  atttachmentuser.id
                                                )
                                              }
                                            >
                                              <g transform="translate(0, 0)">
                                                <path
                                                  fill="none"
                                                  stroke="#fc9b14"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                  strokeMiterlimit={10}
                                                  d="M2.5,6.5v7 c0,1.105,0.895,2,2,2h8c1.105,0,2-0.895,2-2v-7"
                                                />
                                                <line
                                                  data-color="color-2"
                                                  fill="none"
                                                  stroke="#fc9b14"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                  strokeMiterlimit={10}
                                                  x1="1.5"
                                                  y1="3.5"
                                                  x2="15.5"
                                                  y2="3.5"
                                                />
                                                <polyline
                                                  data-color="color-2"
                                                  fill="none"
                                                  stroke="#fc9b14"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                  strokeMiterlimit={10}
                                                  points=" 6.5,3.5 6.5,0.5 10.5,0.5 10.5,3.5 "
                                                />
                                                <line
                                                  fill="none"
                                                  stroke="#fc9b14"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                  strokeMiterlimit={10}
                                                  x1="8.5"
                                                  y1="7.5"
                                                  x2="8.5"
                                                  y2="12.5"
                                                />
                                                <line
                                                  fill="none"
                                                  stroke="#fc9b14"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                  strokeMiterlimit={10}
                                                  x1="11.5"
                                                  y1="7.5"
                                                  x2="11.5"
                                                  y2="12.5"
                                                />
                                                <line
                                                  fill="none"
                                                  stroke="#fc9b14"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                  strokeMiterlimit={10}
                                                  x1="5.5"
                                                  y1="7.5"
                                                  x2="5.5"
                                                  y2="12.5"
                                                />
                                              </g>
                                            </svg>
                                          </a>
                                        </td>
                                      </tr>
                                    );
                                  }
                                )
                              : null}
                          </tbody>
                        </table>
                        {!atttachmentusers.length && !loading ? (
                          <div style={{ textAlign: "center" }}>No Data</div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-default popup-button-default text-w-light"
                    data-dismiss="modal"
                    onClick={() => this.onAttachmentUserListModalVisible()}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger popup-button-danger"
                  >
                    Done
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        {/* Attachment User List Modal End */}

        {/* Add Attachment User Modal Start */}
        <Modal
          visible={addAttachmentUserModalVisible}
          effect="fadeInDown"
          width="900"
        >
          <div style={{ padding: "40px 40px" }}>
            <div className="modal-content" style={{ border: "none" }}>
              <div
                className="modal-header"
                style={{ display: "-webkit-box", padding: 0 }}
              >
                <div className="col-10" style={{ display: "-webkit-box" }}>
                  <figure style={{ marginRight: "20px" }}>
                    <img src={popupLogo} />
                  </figure>
                  <h1 className="heading m-l-28">Select User</h1>
                </div>
                <div className="col-2 text-right">
                  <a
                    href="#"
                    onClick={() => this.onCancelClicked()}
                    className="link-click "
                  >
                    <svg
                      x="0px"
                      y="0px"
                      width="16px"
                      height="16px"
                      viewBox="0 0 16 16"
                      enableBackground="new 0 0 16 16"
                      xmlSpace="preserve"
                    >
                      <g>
                        <line
                          fill="none"
                          stroke="#69951a"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeMiterlimit={10}
                          x1="3.25"
                          y1="3.25"
                          x2="12.75"
                          y2="12.75"
                        />
                        <line
                          fill="none"
                          stroke="#69951a"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeMiterlimit={10}
                          x1="12.75"
                          y1="3.25"
                          x2="3.25"
                          y2="12.75"
                        />
                      </g>
                    </svg>
                  </a>
                </div>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-5">
                    <div className="form-group">
                      <label>NAME</label>
                      <div className="ui-widget">
                        <input
                          id="name"
                          className="form-control autocomplete"
                          placeholder="Please Enter Employee Name"
                          value={name}
                          onChange={(e) =>
                            this.setState({ name: e.target.value })
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-2">
                    <div className="form-group">
                      <button
                        type="button"
                        className="btn btn-danger popup-button-danger m-t-28"
                        onClick={() => this.getUserList()}
                      >
                        Go
                      </button>
                    </div>
                  </div>
                </div>
                <div className="modal-footer m-t-15"></div>
                {users.length ? (
                  <div className="row">
                    <div className="col-md-12">
                      <form onSubmit={this.onCreateDocUploadUsers}>
                        <div
                          className="table-responsive table-container-height"
                          // style={{ height: "55vh" }}
                        >
                          <table className="table table-style-1 m-t-15">
                            <thead>
                              <tr>
                                <th scope="col" width={420}>
                                  NAME
                                </th>
                                <th scope="col" width={400}>
                                  EMAIL ID
                                </th>
                                <th scope="col" width={200}>
                                  ACTION(s)
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {users.length
                                ? users.map((user, index) => {
                                    return (
                                      <tr key={index}>
                                        <td>{user.name}</td>
                                        <td>{user.emailId}</td>
                                        <td>
                                          <input
                                            type="checkbox"
                                            id={user.Id + "_" + user.name}
                                            className="userCheckbox"
                                            onChange={(e) =>
                                              this.onSelectUser(e, user)
                                            }
                                          />
                                        </td>
                                      </tr>
                                    );
                                  })
                                : null}
                            </tbody>
                          </table>
                        </div>
                        <div className="text-right m-t-5">
                          <button
                            type="submit"
                            className="btn btn-danger popup-button-danger"
                          >
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                ) : null}
                {!users.length && isSearched && !loading ? (
                  <div style={{ textAlign: "center" }}>No Data</div>
                ) : null}
              </div>
            </div>
          </div>
        </Modal>
        {/* Add Attachment User Modal End */}
      </div>
    );
  }
}
export default withApollo(Attachments);
